module.exports = __webpack_public_path__ + "img/img_page_07_01.d8691047.jpg";